import Box from "@mui/material/Box";
import {PublishToSystemTable} from "./PublishToSystemTable";

/**
 * Component that allows the user to select which system the DAMS object should be published to.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.t - Translation function for localized text.
 * @param {Object} props.model - The data model used for synchronization.
 * @returns {React.JSX.Element} The rendered PanelPublishToEms component.
 */
export const SelectPublishingSystem = ({t, model}) => {
    return <Box sx={{marginTop: '16px'}}>
        <PublishToSystemTable t={t}
                              models={model}
                              batchMode={false}
        />
    </Box>;
};